/* @ngInject */
export default function ($scope, AuthService, $timeout, LayoutService, $stateParams, toastr, TrainingCourses, $state, DataTablesService) {
	$scope.courseId         = $stateParams.courseId;
	$scope.loading          = true;
	$scope.loadingModules   = true;
	$scope.loadingSummaries = true;

	$scope.dtOptions = DataTablesService.configure({
		title: 'Attempts',
	}, {
		order: [
			[
				3,
				'desc',
			],
		],
	}).options;

	$scope.refresh = () => {
		$scope.loading              = true;
		$scope.loadingModules       = true;
		$scope.loadingUserSummaries = true;

		TrainingCourses.one($scope.courseId)
		               .get({
			               include: 'modules',
		               })
		               .then((course) => {
			               $scope.course = course;

			               if ($scope.course.modules && $scope.course.modules.length > 0) {
				               $scope.course.modules.sort((a, b) => {
					               return a.sort - b.sort;
				               });
			               }

			               $scope.loadingModules = false;

			               if (!$scope.loadingUserSummaries) {
				               $scope.loading = false;
			               }

			               $scope.updateLayout($scope.course.name);
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this course, please try again.', 'Error');

			               $state.go('staff.training.results.root');

			               $scope.loading = false;
		               });

		TrainingCourses.one($scope.courseId)
		               .all('user-summaries')
		               .getList()
		               .then((userSummaries) => {
			               $scope.userSummaries = userSummaries;

			               $scope.loadingUserSummaries = false;

			               if (!$scope.loadingModules) {
				               $scope.loading = false;
			               }
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this course, please try again.', 'Error');

			               $state.go('staff.training.results.root');

			               $scope.loading = false;
		               });
	};

	$scope.updateLayout = (courseName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			courseName,
			'Results',
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       'staff.training.results.root',
				             displayName: 'Results',
			             },
			             {
				             route:       `staff.training.results.view({ moduleId: "${$scope.moduleId}" })`,
				             displayName: courseName,
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		LayoutService.getPageHeader()
		             .onClicked(() => {
			             $scope.refresh();
		             });
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/results/view/controller.js